import React, { FC } from 'react';
import styles from './SiteReadyStep.scss';
import { SiteReadyStepContent } from './components/SiteReadyStepContent';
import { SitePreview } from 'components/SitePreview/SitePreview';
import { useAppStore } from 'stores/state';
import { templateUtils } from 'utils/templates';
import { templates } from 'config/templates';

export const SiteReadyStep: FC = () => {
  const templateSlug = useAppStore((state) => state.templateSlug);
  const template = templateSlug ? templates[templateSlug] : undefined;
  const mobileImageSrc = template ? templateUtils.getAssetUrl(template.assets.mobile) : undefined;

  return (
    <div className={styles.siteReadyStep}>
      <SiteReadyStepContent />
      {template && mobileImageSrc && (
        <div className={styles.siteReadyStepPreview}>
          <SitePreview mobileImageSrc={mobileImageSrc} url={template.siteUrl} />
        </div>
      )}
    </div>
  );
};
